import { LoginProvider } from '../../../../components/account/LoginProvider';

export const Page = () => {
  return <LoginProvider />;
};
